import JSONParseErrorException from '../errors/JSONParseErrorException';
import { ParsedResponse } from '../types/types';

export default async (res: Response): Promise<ParsedResponse> => {
  try {
    const json = await res.json();
    return [res, json];
  } catch (err) {
    if (res.ok || res.status === 404) {
      return [res, {}];
    }

    throw new JSONParseErrorException();
  }
};
